import React from 'react';
import '../../styles/site.css';

const Footer = (props) => {

    if (props.logged === false){
        return (
            <div className="row cs-footer">
                <div className="col-sm-12 col-banner">
                    <div className='footerInternos'>

                    </div>
                </div>
            </div>
        )
    }
    else{
        return (
            <div className="row cs-footer">
                <div className="col-sm-12 col-banner">
                    <div className='footerInternos'>
                    </div>
                </div>
            </div>
        )
    }

}

/* retorna true si al pasar los nextProps a renderizar retorna el mismo resultado que al pasar los prevProps a renderizar, de otro modo retorna false */
function validaProps(prevProps, nextProps) {
    // console.log(equalarray(prevProps.poliza, nextProps, (prevProps.value === nextProps.value), (JSON.stringify(prevProps.poliza[0]) === JSON.stringify(nextProps.poliza[0]))); 
    //si retorna un falso renderiza todo el componente, porque si es falso significa que el valor cambio
    //falso es igual que son diferentes
    //si son muchos objetos va si [0]
    return (prevProps.start === nextProps.start);
  }

export default React.memo(Footer, validaProps);